module.exports = __webpack_public_path__ + "media/DocliniaDemoVideo.3f3b1978.mp4";